import { useEffect, useMemo, useState } from "react"
import Dirs, { GDir } from "../fmanlibs/Dirs"
import { usePath } from "../libs/path/PathProvider"
import { TTreeNode } from "../gui/Tree/TreeNode"
import TreeNodeSession from "../gui/Tree/TreeNodeSession"
import TreeView from "../gui/Tree/TreeView"
import { useRootProvider } from "../fmanlibs/RootProvider"

export default function(){
    const {root} = useRootProvider()
    const {path,setPath} = usePath()
    const [_,selectedId] = path.split("/")
    const session = useMemo(() => root ? new TreeNodeSession(Dirs.i).open(selectedId, Dirs.i) : null, [root])

    useEffect(() => {
        session?.open(selectedId, Dirs.i)
    },[selectedId])

    const onChange = (node:TTreeNode<GDir>) => setPath(`/${node._id}`)
    return root ? <TreeView className="tree" node={root} selectedId={selectedId||"0"} session={session} onChange={onChange}/> : <></>
}